import React from "react";
import Worker from "../modules/Worker/Worker";

export default function WorkerPage() {
  return <Worker />;
}
